import React from "react";
import PlaceTable from "../components/PlaceCategories/PlaceTable";
const PlaceCategories = () => {
  return (
    <>
      <PlaceTable />
    </>
  );
};

export default PlaceCategories;
